import { lazy } from "react";

import { IRoute, RouteType } from "./types";

/* - SideBar Routes - */
const SideBarFields = lazy(() => import("../SideBar/Fields"));
const SideBarDesign = lazy(() => import("../SideBar/Design"));
const SideBarLogic = lazy(() => import("../SideBar/Logic"));
const SideBarValidation = lazy(() => import("../SideBar/Validation"));
const SideBarIntegration = lazy(() => import("../SideBar/Integration"));
const SideBarPayment = lazy(() => import("../SideBar/Payment"));
const SideBarPreview = lazy(() => import("../SideBar/Preview"));
const Promocodes = lazy(() => import('../SideBar/Payment/Promocodes'));
const Receipt = lazy(() => import('../SideBar/Payment/PaymentReceipt'));
const Paypal = lazy(() => import('../SideBar/Payment/Methods/Paypal'));
const Stripe = lazy(() => import('../SideBar/Payment/Methods/Stripe'));
const Square = lazy(() => import('../SideBar/Payment/Methods/Square'))

export const sideBarRoutes: IRoute[] = [
    { path: RouteType.Edit, element: SideBarFields,  meta: { caseSensetive: true } },
    { path: RouteType.Design, element: SideBarDesign, meta: { caseSensetive: false } },
    { path: RouteType.Logic, element: SideBarLogic, meta: { caseSensetive: false } },
    { path: RouteType.Validation, element: SideBarValidation, meta: { caseSensetive: false } },
    { path: RouteType.Integration, element: SideBarIntegration, meta: { caseSensetive: false } },
    { path: RouteType.Preview, element: SideBarPreview, meta: { caseSensetive: false } },
    { path: RouteType.Payment, element: SideBarPayment,children:[
    { path:RouteType.Promocode, element: Promocodes, meta: { caseSensetive: false }},
    { path: RouteType.Receipt, element: Receipt, meta: { caseSensetive: false }},
    { path: RouteType.PayPal, element: Paypal, meta: { caseSensetive: false }},
    { path: RouteType.Stripe, element: Stripe, meta: { caseSensetive: false }},
    { path: RouteType.Square, element: Square, meta: { caseSensetive: false }},
    ], meta: { caseSensetive: false } },
];

/* - Pages Routes - */
const PagesPreview = lazy(() => import("../Pages/components/Modes/Preview"));
const PagesEdit = lazy(() => import("../Pages/components/Modes/Edit"));
const PagesDesign = lazy(() => import("../Pages/components/Modes/Design"));
const PagesPayment = lazy(() => import("../Pages/components/Modes/Payment"));
const PagesValidation = lazy(() => import("../Pages/components/Modes/Validation"));
const PagesIntegration = lazy(() => import("../Pages/components/Modes/Integration"));
const PagesLogic = lazy(() => import("../Pages/components/Modes/Logic"));

export const pagesRoutes: IRoute[] = [
    { path: RouteType.Edit, element: PagesEdit, meta: { caseSensetive: true } },
    { path: RouteType.Design, element: PagesDesign, meta: { caseSensetive: false } },
    { path: RouteType.Preview, element: PagesPreview, meta: { caseSensetive: false } },
    { path: RouteType.Payment, element: PagesPayment, meta: { caseSensetive: false } },
    { path: RouteType.Validation, element: PagesValidation, meta: { caseSensetive: false } },
    { path: RouteType.Integration, element: PagesIntegration, meta: { caseSensetive: false } },
    { path: RouteType.Logic, element: PagesLogic, meta: { caseSensetive: false } },
];
